import FullTemplate from "../../components/Assembler/JSON/FullTemplate";
import { ITypeMedia } from "../../interfaces/Artists";
import type Cameras from "../Devices/Cameras";

class StreamerAdapterModel {
  private Model = FullTemplate;
  private Cameras: Cameras | null = null;
  constructor() {
    return this;
  }

  async setCameras(cameras: Cameras) {
    this.Cameras = cameras;
    await this.setHardware();
  }

  private async setHardware() {
    // Camera by default
    const defaultCamera = this.getDefaultCamera();
    // Area camera
    const areaDisplay = this.Model.areas[0];
    // Apply camera to area
    areaDisplay.media.resource = {
      id: defaultCamera.id,
      type: ITypeMedia.camera,
      source: {
        deviceId: defaultCamera.deviceId,
        groupId: defaultCamera.groupId,
        kind: defaultCamera.kind,
        label: defaultCamera.label,
      },
    };
    this.Model.areas = [areaDisplay];
  }

  private getDefaultCamera() {
    const cameraDefault = this.Cameras?.getAll().find(
      (device) => device.deviceInfo.kind === "videoinput"
    );
    const defaultInfoDevice = {
      id: cameraDefault?.id || "",
      deviceId: cameraDefault?.deviceInfo.deviceId || "",
      groupId: cameraDefault?.deviceInfo.groupId || "",
      kind: cameraDefault?.deviceInfo.kind || "",
      label: cameraDefault?.deviceInfo.label || "",
    };
    return defaultInfoDevice;
  }

  getModel() {
    return this.Model;
  }
}

export default StreamerAdapterModel;
